@if (isDisney) {
<div class="communication-container">
  <mb-communication>
    <mb-communication-warning-icon></mb-communication-warning-icon>
    <mb-communication-title>
      <p i18n="@@ticket_purchase_policy_communication_title">
        <strong
          >Nuevo protocolo de venta de tickets y hoteles en Disney por COVID-19</strong
        >
      </p>
    </mb-communication-title>
    <mb-communication-message>
      <p i18n="@@ticket_purchase_policy_communication_message">
        Debido al nuevo protocolo de ventas de Walt Disney World Resorts Orlando, es
        <strong>obligatorio que verifiques la disponibilidad de los parques</strong>
        para las fechas en las que deseas concurrir,
        <strong>previo a realizar tu compra en Almundo.</strong><br />
        Una vez que compres debes seguir una serie de pasos para confirmar tu reserva.
      </p>
    </mb-communication-message>
    <button mb-communication-button (click)="openModal()">
      <span i18n="@@ticket_purchase_policy_communication_button"
        >Ver los pasos a seguir</span
      >
    </button>
  </mb-communication>
</div>
}
